var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",on:{"click":function($event){$event.preventDefault();return _vm.goTop.apply(null, arguments)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"glyphicon glyphicon-chevron-up",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }